<template>
  <div v-if="!loading">
    <date-form-group
        :value="value.publish_from"
        name="publish_from"
        label="Publish From"
        help-text="Filter the competition on publication date."
        :error="(errors['publish_from'] || [])[0]"
        @input="emit('publish_from', $event)"
    ></date-form-group>

    <date-form-group
        :value="value.publish_to"
        name="publish_to"
        label="Publish To"
        help-text="Filter the competition on publication date."
        :error="(errors['publish_to'] || [])[0]"
        @input="emit('publish_to', $event)"
    ></date-form-group>

    <TypeaheadFormGroup
        v-model="value.project_id"
        name="project_id"
        label="Project"
        help-text="Filter the competition by project."
        :error="(errors['project_id'] || [])[0]"
        endpoint="/api/v2/projects"
        :token="shared.token"
        path="data.data"
        placeholder="Search..."
        :result-label-property="row => row.attributes.name"
        :load-initial="true"
    />

    <RepeatableFormGroup
        :value="value.ad_formats"
        label="Ad Formats"
        help-text="Filter the competition on ad formats. If no ad formats are selected, all ad formats will count."
        empty-text="No ad formats added."
        :errors="adFormatErrors"
        @input="emit('ad_formats', $event)"
    >
      <template v-slot:default="{ data, index, change, errors }">
        <div class="row">
          <div class="col-xs-12">
            <SelectWidget
                :value="data.type"
                @input="change(index, 'type', $event)"
                :options="[{value: 'publication', label: 'Publication Ad Format'}, {value: 'time', label: 'Time Ad Format'}]"
                placeholder="Select type..."
                :error="(errors.type || [])[0]"
            />
          </div>

          <div class="col-xs-12">
            <SelectWidget
                v-if="data.type === 'publication'"
                :value="data.id"
                @input="change(index, 'id', $event)"
                :options="publicationAdFormats.map(publicationAdFormat => ({value: publicationAdFormat.id, label: publicationAdFormat.attributes.full_name}))"
                placeholder="Select ad format..."
                :error="(errors.id || [])[0]"
            />

            <SelectWidget
                v-if="data.type === 'time'"
                :value="data.id"
                @input="change(index, 'id', $event)"
                :options="timeAdFormats.map(timeAdFormat => ({value: timeAdFormat.id, label: timeAdFormat.attributes.full_name}))"
                placeholder="Select ad format..."
                :error="(errors.id || [])[0]"
            />
          </div>
        </div>
      </template>
    </RepeatableFormGroup>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import RepeatableFormGroup from '../../../Forms/RepeatableFormGroup'

export default {
  components: {DateFormGroup, RepeatableFormGroup, SelectWidget,TypeaheadFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  data() {
    return {
      publicationAdFormats: null,
      timeAdFormats: null,

      loading: true,

      shared: store
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    adFormatErrors() {
      return Object.entries(this.errors)
          .filter(entry => entry[0].startsWith('ad_formats.'))
          .reduce((result, entry) => ({
            ...result,
            [entry[0].substring('ad_formats.'.length)]: entry[1]
          }), {})
    }
  },

  methods: {
    load() {
      Promise.all([
        http.getList('/api/v2/publication-based-ad-formats'),
        http.getList('/api/v2/time-based-ad-formats')
      ]).then(responses => {
        this.publicationAdFormats = responses[0]

        this.timeAdFormats = responses[1]

        this.loading = false
      })
    },

    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
